import React,{useEffect} from "react";
import {
    Grid,
    Paper,
    Button,
    Typography
  } from '@mui/material/';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import FilledInput from '@mui/material/FilledInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import { serverHost } from "../../redux/reducers/reducer";
import Swal from 'sweetalert2'
import useAuth from '../../hooks/Auth/useAuth';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ROLES_ARRAY } from "../../redux/context/allowedTypes";
import "./register.css"

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
var printObj = function(obj) {
    var string = '';

    for(var prop in obj) {
        string+= "<div style='margin:5px;' ><b>" +prop +"</b>" + ' :   ' + obj[prop]+'</br></div>';
    }
    return string;
}
const ValidateEmail = (input) => 
{
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input))
        return (true)
    return (false)
}

const validateName = (input) =>{
    if(/^[A-Za-z\s]+$/.test(input) || (/[\u0590-\u05FF]/).test(input))
      return true;
    else
      return false;
  }
function getStyles(cloumn, columnName, theme) {
    return {
      fontWeight:
        columnName.indexOf(cloumn) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }



export default function RegisterUser({handleCloseDialog}){
    const {auth} = useAuth();
    const theme = useTheme();
    const {sitesList} = useAuth();
    const navigate = useNavigate()
    const [repeatPassword,setRepeatPassword] = React.useState("");
    const [checkedPass, setCheckedPass] = React.useState(true);
    const [checkEmail, setCheckedEmail] = React.useState(true)
    const [showPassword,setShowPassword] = React.useState(false);
    const [checkFirstName, setCheckFirstName] = React.useState(true)
    const [checkLastName, setCheckLastName] = React.useState(true)
    const [checkUserName, setCheckUserName] = React.useState(true)
    const [error,setError] = React.useState('');
    const [user,setUser]=React.useState({
        firstName:"",
        lastName:"",
        userName :"", 
        email:"",
        siteList:[],
        role:"",
        password:""
    })
    const [sites, setSitesList] = React.useState([]);
    const [register,setRegister] = React.useState(false)

    const clearState = ()=>{
        setUser ({
            firstName:"",
            lastName:"",
            userName :"", 
            email:"",
            siteList:[],
            role:"",
            password:"",
        });
        setCheckUserName(true);
        setCheckFirstName(true);
        setCheckLastName(true);
        setShowPassword(false);
        setCheckedEmail(true);
        setCheckedPass(true);
        setRepeatPassword('');
        setSitesList([])
        setError('');
        setRegister(false);
    }
    const handleSitesList = (event) => {
        const {
            target: { value },
        } = event;
        
        setSitesList(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        setRegister(false)
        setError("")
        setUser(prevState => ({
            ...prevState,
            ['siteList']: event.target.value
        }));
    };


    
    const chekedPassword= (repeat_password)=>{
        setCheckedPass(repeat_password === user.password)
    }
    const handleChange = (type,event) => {
        event.preventDefault();
        setError("")
        setRegister(false)
        const input = event.target.value
        if(type ==='email') {
            const isValid=ValidateEmail(input)
            setCheckedEmail(isValid)
        }
        if(type ==='firstName' ) {
            const isValid=validateName(input )
            setCheckFirstName(isValid && input.length >= 2)
        }
        if(type ==='lastName' ) {
            const isValid=validateName(input )
            setCheckLastName(isValid && input.length >= 2)
        }
        if(type ==='userName') {
            setCheckUserName(input.length >= 2)
        }
        setUser(prevState => ({
            ...prevState,
            [type]: input
        }));
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
      };
    
      useEffect(()=>{
          if(register){
            if(!checkedPass || user.role === '' || user.siteList.length === 0 || !checkFirstName || !checkLastName ||!checkUserName  ||user.password ==='' || user.email ==='' || !checkEmail ||repeatPassword === ''){
                setError("Please fill / currect all the fields!")
                setRegister(false)
            }else{
                const print = printObj(user);
                handleCloseDialog();
                Swal.fire({
                    title: 'Are you sure You want to add this user ?',
                    html:`${print}`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Add!'
                  }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(serverHost() + '/user/regitser',{...user})
                        .then(
                            res=>{
                                if(res.status === 404){
                                    setError("Username already exists")
                                }
                                if(res.status === 500){
                                    setError("Please try again")
                                }else if(res.status === 200){
                                    clearState()
                                    Swal.fire({
                                        position: 'bottom-end',
                                        icon: 'success',
                                        customClass: {
                                            container: 'my-swal'
                                        },
                                        title: 'User registration Successed !',
                                        showConfirmButton: true,
                                        timer: 1500
                                      })
                                      setTimeout(()=>{
                                        handleCloseDialog(false)
                                        },[1000])
                                      
                                }
                            }
                            )
                        .catch(error=>{
                            console.error(error);
                            setError("One or more are incorrect !")
                        })
                    }
                  })
            }
        }
    },[register])
    return (
    <>
        <div    style={{
                    maxHeight: '79vh',
                   overflowY:'scroll',
                    
                }}>
               <div style={{
                   position:'absolute',
                   top: '1vh',
                   width: '50%',
                   left: '25%',
                   textAlign:'center',
                   
               }}> <h3>Register new User</h3>
               </div>
            <Grid
             sx={{
                    position:'relative',
                    top:'1vh',
                    }}
                container
                direction={'column'}
                spacing={1}
                justify={'center'}
                alignItems={'center'}
            >
                <Grid item xs={12}>
                    <InputLabel required sx={{color:"#1E1E1E"}} htmlFor="firstName"><b>First Name</b></InputLabel>
                    <FilledInput
                        id="firstName"
                        type={"text"}
                        inputProps={{ maxLength: 20 }}
                        value={user.firstName}
                        onChange={(e)=>handleChange('firstName',e)}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="user "
                                edge="end"
                                disabled
                            >
                        <AccountCircle />
                            </IconButton>
                        </InputAdornment>
                        }
                        label="firstName"
                    />
                    <InputLabel htmlFor="username-error" ><b style={{opacity:'0.9',fontSize:'0.8rem'}}>{checkFirstName ? null :'Must be only and at least 2 charachters !'}</b></InputLabel>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel required sx={{color:"#1E1E1E"}} htmlFor="lastName"><b>Last Name</b></InputLabel>
                    <FilledInput
                        id="lastName"
                        type={"text"}
                        value={user.lastName}
                        inputProps={{ maxLength: 20 }}
                        onChange={(e)=>handleChange('lastName',e)}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                            aria-label="user "
                            edge="end"
                            disabled
                            >
                            <AccountCircle />
                            </IconButton>
                        </InputAdornment>
                        }
                        label="lastName"
                    />
                <InputLabel htmlFor="username-error" ><b style={{opacity:'0.9',fontSize:'0.8rem'}}>{checkLastName ? null :'Must be only and at least 2 charachters !'}</b></InputLabel>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel required sx={{color:"#1E1E1E"}} htmlFor="userName"><b>User Name</b></InputLabel>
                    <FilledInput
                        id="userName"
                        type={"text"}
                        inputProps={{ maxLength: 20 }}
                        value={user.userName}
                        onChange={(e)=>handleChange('userName',e)}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                            aria-label="user "
                            edge="end"
                            disabled
                            >
                            <AccountCircle />
                            </IconButton>
                        </InputAdornment>
                        }
                        label="userName"
                    />
                    <InputLabel htmlFor="username-error" ><b style={{opacity:'0.9',fontSize:'0.8rem'}}>{checkUserName ? null :'Must be at least 2 charachters !'}</b></InputLabel>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel required sx={{color:"#1E1E1E"}} htmlFor="email"><b>Email</b></InputLabel>
                    <FilledInput
                        id="email"
                        type={"text"}
                        value={user.email}
                        inputProps={{ maxLength: 30 }}
                        onChange={(e)=>handleChange('email',e)}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                            aria-label="user "
                            edge="end"
                            disabled
                            >
                            <AccountCircle />
                            </IconButton>
                        </InputAdornment>
                        }
                        label="Email"
                    />
                    <InputLabel error htmlFor="email-error" ><b style={{opacity:'0.9',fontSize:'0.8rem'}}>{checkEmail ? null :'Email invalid'}</b></InputLabel>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel required sx={{color:"#1E1E1E"}} htmlFor="sites"><b>Sites List</b></InputLabel>
                    <Select
                        labelId="chip-sites"
                        
                        id="sites"
                        multiple
                        value={sites}
                        sx={{minWidth:'30ch'}}
                        onChange={handleSitesList}
                        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                                <Chip key={value} label={value} />
                            ))}
                            </Box>
                        )}
                        MenuProps={MenuProps}
                        >
                        {sitesList.map((name) => (
                            <MenuItem
                            key={name}
                            value={name}
                            style={getStyles(name, sitesList, theme)}
                            >
                            {name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel required sx={{color:"#1E1E1E"}} htmlFor="role"><b>Role</b></InputLabel>
                    <Select
                        labelId="role-select"
                        id="role"
                        value={user.role}
                        sx={{minWidth:'30ch'}}
                        onChange={(e)=>handleChange('role',e)}
                    >
                        {ROLES_ARRAY.map((role) => (
                            <MenuItem
                            key={role}
                            value={role}
                            >
                            {role}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel required htmlFor="password" sx={{color:"#1E1E1E"}}><b>Password</b></InputLabel>
                    <FilledInput
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        value={user.password}
                        inputProps={{ maxLength: 20 }}
                        onChange={(e)=>handleChange('password',e)}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={()=>{setShowPassword(!showPassword)}}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                        }
                        label="Password"
                    />
                </Grid>
                <Grid item xs={12}>
                    <InputLabel required htmlFor="repeat-password" sx={{color:"#1E1E1E"}}><b>Repeat Password</b></InputLabel>
                    <FilledInput
                        id="repeat-password"
                        type={showPassword ? 'text' : 'password'}
                        inputProps={{ maxLength: 20 }}
                        value={repeatPassword}
                        onChange={(e)=>{setRepeatPassword(e.target.value);chekedPassword(e.target.value)}}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={()=>{setShowPassword(!showPassword)}}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                        }
                        label="Repeat Password"
                    />
                    <InputLabel htmlFor="password-error" ><b style={{opacity:'0.9',fontSize:'0.8rem'}}>{checkedPass ? null :'Password incorrect '}</b></InputLabel>
                </Grid>
                <Grid item xs={12} sx={{
                    mb:3,
                }}>
                    <Typography><b style={{color:'#DE1A1A'}}> {error}</b></Typography>
                </Grid>
                
            </Grid>
            <div style={{
                   position:'absolute',
                   bottom: '1vh',
                   width: '50%',
                   left: '25%',
                   marginTop:'4vh',
                   textAlign:'center',
                   
               }}> 
                    <Button fullWidth size="large"  variant="contained" onClick={()=>setRegister(true)}> Register </Button>

               </div>
        </div>
</>
    );
}